import { IEProtectConfigure } from "../models/funding.model";

/* eslint-disable @typescript-eslint/no-explicit-any */
export const eProtectConfigure = (
  paypageId: string,
  eProtectCSS: string,
  eProtectReportGroup: string,
  eProtectIframeClientCallBack: any,
  inputsEmptyCallBack: any
): IEProtectConfigure => {

  // amwagerWPv5a
  // AmWagerPro
return {
  "paypageId": paypageId,
  "style": eProtectCSS,
  "height": "300px",
  "reportGroup": eProtectReportGroup,
  "timeout": 15000,
  "div": "eProtectiframe",
  "callback": eProtectIframeClientCallBack,
  "showCvv": true,
  // "noScrollBar" : true,
  "months": {
    "1": 'January',
    "2": 'Febuary',
    "3": 'March',
    "4": 'April',
    "5": 'May',
    "6": 'June',
    "7": 'July',
    "8": 'August',
    "9": 'September',
    "10": 'October',
    "11": 'November',
    "12": 'December'
  },
  "numYears": 15,
  "tooltipText": 'A CVV is the 3 digit code on the back of your Visa, ' +
    'MasterCard and Discover or a 4 digit code on the front of your American Express',
  "tabIndex": {
    "cvv": 2,
    "accountNumber": 1,
    "expMonth": 3,
    "expYear": 4
  },
  "placeholderText": {
    "cvv":"CVV",
    "accountNumber":'Account Number',
  },
  "inputsEmptyCallback": inputsEmptyCallBack,
  "clearCvvMaskOnReturn" : false,
  "enhancedUxFeatures" : {
    "inlineFieldValidations": true,
    "numericInputsOnly" : true
  },
  "htmlTimeout": 15000,
  // "action" : 'configure'
}
};
